import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CustomerRole } from '../services/constants';
import { hasRole } from '../shared/common';

@Component({
    selector: 'app-custom-widgets',
    templateUrl: './custom-widgets.component.html',
    styleUrls: ['./custom-widgets.component.scss']
})
export class CustomWidgetsComponent implements OnInit {

    constructor(private router: Router) {}

    ngOnInit(): void {
        if (!hasRole(CustomerRole.OEM)) {
            this.router.navigate(['not-auth']);
        }
    }
}
